<template>
  <nav class="panel">
    <p class="panel-tabs is-size-6">
        <a @click="$parent.switchTab('household')" :class="{ 'is-active': $parent.tab == 'household' }">
            <span class="icon is-small"><i class="fa fa-home"></i></span>
            <span>{{ $t("Household") }}</span>
        </a>
        <a @click="$parent.switchTab('people')" :class="{ 'is-active': $parent.tab == 'people' }">
            <span class="icon is-small"><i class="fa fa-users"></i></span>
            <span>{{ $t("People") }}</span>
        </a>
        <a @click="$parent.switchTab('tags')" :class="{ 'is-active': $parent.tab == 'tags' }">
            <span class="icon is-small"><i class="fa fa-tags"></i></span>
            <span>{{ $t("Tags") }}</span>
        </a>
        <a @click="$parent.switchTab('meter')" :class="{ 'is-active': $parent.tab == 'meter' }">
            <span class="icon is-small"><i class="fa fa-tachometer"></i></span>
            <span>Meter</span>
        </a>
    </p>
  </nav>
</template>

<script>
export default {
  name: "AccountTabs"
};
</script>